import {Component, ElementRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';

import * as Showdown from 'showdown';

import {Language} from 'classes/language';
import {Tip} from 'shared/models/tips/tip';
import {Tiplist} from 'shared/models/tips/tiplist';
import {TranslatedText} from 'shared/models/translated-text';
import {TipListDetailsService} from './services/tip-list-details.service';

@Component({
  selector: 'tip-list-details',
  templateUrl: './tip-list-details.component.html',
  styleUrls: ['./tip-list-details.component.css'],
})

export class TipListDetailsComponent {

  public tiplist: Tiplist = <Tiplist> {tips: [], keywords: {de: '', en: ''}};
  public title: string = 'Neue Tipliste';
  public languages: Array<Language> = Language.defaultLanguages;
  public language: string = this.languages[0].code;
  public isUsedInQuestionChain: boolean = false;

  private converter: Showdown.Converter = new Showdown.Converter();
  public showMarkdownOutput: Array<boolean> = [];
  private markdownOutput: Array<any> = [];

  @ViewChild('formElement') formElement: ElementRef;

  constructor(private detailsService: TipListDetailsService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.converter.setFlavor('github')
  }

  public ngOnInit(): void {
    this.activatedRoute.params.map((routeParameters: Params) => {
      return routeParameters['tiplistId'];
    })
    .subscribe((tiplistId: string) => {
      if (!tiplistId) {
        return;
      }

      this.title = 'Tipliste bearbeiten';
      this.detailsService.getTiplistById(tiplistId)
        .subscribe((tiplist: Tiplist) => {
          this.tiplist = tiplist;
          this.tiplist.tips.forEach((tip, i) => {
            this.showMarkdownOutput[i] = true;
            this.markdownOutput[i] = {de: '', en: ''};
            this.updateMarkdown(i);
          });
          if (!tiplist.keywords) {
            tiplist.keywords = TranslatedText.createEmptyInstance();
          }
        });
    });
  }

  public setLanguage(language: Language): void {
    this.language = language.code;
  }

  public saveTiplist(): void {
    const keywords = this.tiplist.keywords;
    this.tiplist.keywords
    this.detailsService.saveTiplist(this.tiplist)
      .subscribe((savedTiplist: Tiplist) => {
        this.router.navigateByUrl('/tiplists');
      });
  }

  public updateTiplist(): void {
    this.detailsService.updateTiplist(this.tiplist)
      .subscribe((updatedTiplist: Tiplist) => {
        this.router.navigateByUrl('/tiplists');
      });
  }

  public addTip(): void {
    const newTip: Tip = {
      title: '',
      text: TranslatedText.createEmptyInstance(),
      active: false,
    };

    newTip.text[this.language] = '';
    this.tiplist.tips.unshift(newTip);
    this.showMarkdownOutput.unshift(false);
    this.markdownOutput.unshift({de: '', en: ''});
    setTimeout(() => { this.formElement.nativeElement.elements[9].focus(); });
  }

  public toggleActive(tip: Tip): void {
    tip.active = !tip.active;
  }

  public deleteTip(tipIndex: number): void {
    this.tiplist.tips.splice(tipIndex, 1);
  }

  public get submitButtonText(): string {
    return this.tiplist._id ? 'Speichern' : 'Erstellen';
  }

  public onSubmit(): void {
    if (this.tiplist._id) {
      return this.updateTiplist();
    }
    return this.saveTiplist();
  }

  public trackByIndex(index: number, value: number): number {
    return index;
  }

  private setMarkdownOutput(i: number, value: boolean): void {
    console.log("mark")
    this.showMarkdownOutput[i] = value;
  }

  private updateMarkdown(i): void {
    this.markdownOutput[i][this.language] = this.converter.makeHtml(this.tiplist.tips[i].text[this.language]);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-details/tip-list-details.component.ts